/**
 * Timezone configuration for repubs that require non-UTC date handling.
 *
 * Used for:
 * - Date facet aggregation (subeventStartDateLocal runtime field)
 * - Range query time_zone parameter for "upcoming events" filter
 */
export const REPUB_TIMEZONES = {
  GZ: 'Europe/Rome', // CET/CEST
  OC: 'Europe/London', // GMT/BST
} as const;

export type RepubWithTimezone = keyof typeof REPUB_TIMEZONES;

export function getTimezoneForRepub(repubName: string): string | undefined {
  return REPUB_TIMEZONES[repubName as RepubWithTimezone];
}
